(function () {
  const AUTOPLAY_DELAY = 3200;
  const TRANSITION_SPEED = 420;
  const AUTOPLAY_RESUME_DELAY = 260;
  const STALL_CHECK_INTERVAL = 1600;
  const STALL_MAX_TICKS = 3;

  const buildDotsPagination = (swiper, paginationEl, total, isLoopEnabled) => {
    if (!paginationEl) return;
    paginationEl.innerHTML = "";
    paginationEl.classList.add("selling-points__pagination--dots");

    const dots = [];
    for (let i = 0; i < total; i += 1) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "selling-points__dot";
      dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
      dot.addEventListener("click", () => {
        if (isLoopEnabled) {
          swiper.slideToLoop(i, TRANSITION_SPEED, true);
        } else {
          swiper.slideTo(i, TRANSITION_SPEED, true);
        }
        window.setTimeout(() => {
          if (swiper.autoplay && typeof swiper.autoplay.start === "function") {
            swiper.autoplay.start();
          }
        }, AUTOPLAY_RESUME_DELAY);
      });
      paginationEl.appendChild(dot);
      dots.push(dot);
    }

    const updateActive = () => {
      const active = isLoopEnabled ? swiper.realIndex : swiper.activeIndex;
      dots.forEach((dot, idx) => dot.classList.toggle("is-active", idx === active));
    };

    swiper.on("slideChange", updateActive);
    updateActive();
  };

  const startStallWatchdog = (swiper, shouldEnableLoop) => {
    if (!shouldEnableLoop) return () => {};

    let lastRealIndex = swiper.realIndex;
    let stallTicks = 0;
    const timer = window.setInterval(() => {
      if (swiper.destroyed || document.visibilityState !== "visible") return;

      const current = swiper.realIndex;
      if (current === lastRealIndex && !swiper.animating) {
        stallTicks += 1;
      } else {
        stallTicks = 0;
      }
      lastRealIndex = current;

      if (stallTicks < STALL_MAX_TICKS) return;
      stallTicks = 0;

      swiper.slideNext(TRANSITION_SPEED, true);
      if (swiper.autoplay && typeof swiper.autoplay.start === "function") {
        swiper.autoplay.start();
      }
    }, STALL_CHECK_INTERVAL);

    return () => window.clearInterval(timer);
  };

  const initSellingPoints = () => {
    document.querySelectorAll(".selling-points__slider").forEach((el) => {
      if (el.classList.contains("selling-points-initialized")) return;
      el.classList.add("selling-points-initialized");

      const section = el.closest(".selling-points");
      const paginationEl = section ? section.querySelector(".selling-points__pagination") : null;
      const originalSlidesTotal = el.querySelectorAll(".swiper-wrapper > .swiper-slide").length;
      const shouldEnableLoop = originalSlidesTotal > 1;

      const slider = new Swiper(el, {
        slidesPerView: 1.15,
        centeredSlides: true,
        centeredSlidesBounds: false,
        spaceBetween: 16,
        speed: TRANSITION_SPEED,
        loop: shouldEnableLoop,
        normalizeSlideIndex: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoplay: shouldEnableLoop
          ? {
              delay: AUTOPLAY_DELAY,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              waitForTransition: false,
            }
          : false,
        on: {
          init(swiper) {
            if (shouldEnableLoop) {
              swiper.slideToLoop(0, 0, false);
            } else {
              swiper.slideTo(0, 0, false);
            }
          },
        },
        breakpoints: {
          990: {
            slidesPerView: 1.35,
            spaceBetween: 16,
          },
        },
      });

      buildDotsPagination(slider, paginationEl, originalSlidesTotal, shouldEnableLoop);
      const stopWatchdog = startStallWatchdog(slider, shouldEnableLoop);

      const handleVisibility = () => {
        if (!shouldEnableLoop || slider.destroyed || !slider.autoplay) return;
        if (document.visibilityState === "visible") {
          slider.autoplay.start();
          return;
        }
        slider.autoplay.stop();
      };
      document.addEventListener("visibilitychange", handleVisibility);

      slider.on("touchEnd", () => {
        if (slider.autoplay && typeof slider.autoplay.start === "function") {
          window.setTimeout(() => slider.autoplay.start(), AUTOPLAY_RESUME_DELAY);
        }
      });
      slider.on("transitionEnd", () => {
        if (slider.autoplay && typeof slider.autoplay.start === "function" && !slider.autoplay.running) {
          slider.autoplay.start();
        }
      });
      slider.on("destroy", () => {
        stopWatchdog();
        document.removeEventListener("visibilitychange", handleVisibility);
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initSellingPoints);
  document.addEventListener("shopify:section:load", initSellingPoints);
})();
